const items = [
  { label: '자재입고공정(PU-01)', value: 'PU-01' },
  { label: '용수공급공정(PU-02)', value: 'PU-02' },
  { label: '사용물질저장공정(PU-03)', value: 'PU-03' },
  { label: '함침전극봉공정(PU-04)', value: 'PU-04' },
  { label: '산소공정(PU-05)', value: 'PU-05' },
  { label: 'ROLL연마공정(PU-06)', value: 'PU-06' },
  { label: '공기압축공정(PU-07)', value: 'PU-07' },
  { label: '기체연료사용공정(PU-08)', value: 'PU-08' },


  { label: '용해공정(P-01)', value: 'P-01' },
  { label: '정련공정(P-02)', value: 'P-02' },
  { label: '연속주조공정(P-03)', value: 'P-03' },
  { label: '압연공정(P-04)', value: 'P-04' },
  { label: '압연공정(P-04)_생산품', value: 'P-04_생산품' },
  { label: '압연공정(P-04)_처리', value: 'P-04_처리' },
  { label: '압연공정(P-04)_봉강', value: 'P-04_봉강' },
  { label: '압연공정(P-04)_판매', value: 'P-04_판매' },
  { label: '이화학시험공정(P-05)', value: 'P-05' },

  { label: '폐수처리공정(PW-01)', value: 'PW-01' },
  { label: '폐기물보관공정(PW-02)', value: 'PW-02' },
  { label: '슬래그처리공정(PW-03)', value: 'PW-03' },
  { label: '비점오염저감공정(PW-04)', value: 'PW-04' },

  { label: '오수처리공정(PE-01)', value: 'PE-01' },
]

export default {
  items,
  getLabel(value) {
    if (items.find(item => item.value === value)) {
      return items.find(item => item.value === value).label || ''
    }

    return ''
  },
  getValue(label) {
    if (items.find(item => item.label === label)) {
      return items.find(item => item.label === label).value || ''
    }
    return ''
  },
  findItems(label) {
    return items.filter(item => item.label.indexOf(label) > -1) || []
  },
  getItemWithLabel(label) {
    if (items.find(item => item.label === label)) {
      return items.find(item => item.label === label) || ''
    }

    return ''
  },
  getItemWithValue(value) {
    if (items.find(item => item.value === value)) {
      return items.find(item => item.value === value) || ''
    }

    return ''
  }
}
